__webpack_require__.p = "https://matchcenter-api.24media.gr/widget/28067d2d4f04bc85d81b/";